export default __webpack_public_path__ + "static/media/banner_bg.8169c482.jpg";